import React from 'react';
import { Modal } from 'react-bootstrap';
import 'react-select/dist/react-select.css';
import { connect } from 'react-redux';
import {
  getFormValues,
  reduxForm,
  FieldArray,
  Field,
  formValueSelector,
  initialize,
} from 'redux-form';
import validator from 'validator';
import {
  cancelAddItems,
  addItemsOnSearch,
  addItemsOnChangeSelect,
  addItemsHideAlreadyAddedAlert,
  addItemsGetItemsRequest,
  addItemsGetIngredientsRequest,
  onChangeNamespace,
} from 'actions/inventory/adjustment';
import { askConfirmAction } from 'actions/confirm-action';
import ModalHeader from 'components/Modal/ModalHeader';
import SettingField from 'components/Fields/ReduxForm/SettingField';
import WarningMessage from 'components/WarningMessage/WarningMessage';
import ItemHasRecipe from 'components/ItemHasRecipe';
import SearchModal from 'components/Fields/ReduxForm/SearchModal';
import ListItemModal from 'components/ListItemModal';
import styles from './AddItemsModal.css';

const nameField = props => {
  const { input } = props;
  return (
    <input
      {...input}
      defaultValue={input.value}
      readOnly
      className={`form-control ${styles.name}`}
    />
  );
};

const stockField = props => {
  const { input } = props;
  return (
    <input
      {...input}
      placeholder={input.value}
      readOnly
      className={`${styles.stock} form-control`}
    />
  );
};

const toNonNegative = value => {
  if (isNaN(value)) {
    return '';
  }
  if (value === '') {
    return '';
  }
  // ni gak pake fungsi abs karena kalo ngetik 100.0 di abs jatuhnya 100
  if (value < 0) {
    return -value;
  }
  return value;
};

const validate = (values, props) => {
  const errors = {};
  if (props.namespace === 'items') {
    const itemsErrors = [];
    if (values.items) {
      values.items.forEach((member, index) => {
        const memberErrors = {};
        if (!member.quantity && `${member.quantity}` !== '0') {
          memberErrors.quantity = 'Please enter a value';
          itemsErrors[index] = memberErrors;
        } else if (!validator.isNumeric(`${member.quantity}`)) {
          memberErrors.quantity = 'Please enter a valid Number';
          itemsErrors[index] = memberErrors;
        } else if (parseFloat(member.quantity) - 999999999 > 0.000001) {
          memberErrors.quantity = 'Quantity must be less than 999999999';
          itemsErrors[index] = memberErrors;
        }
      });
    }
    if (itemsErrors.length) {
      errors.items = itemsErrors;
    }
  } else if (
    !values.quantity &&
    (values.quantity !== '0' && values.quantity !== 0)
  ) {
    errors.quantity = 'Please enter a value';
  } else if (parseFloat(values.quantity) - 999999999.99 > 0.000001) {
    errors.quantity = 'Quantity must be less than 999999999.99';
  }

  return errors;
};

const renderField = (member, index, fields) => {
  const adjustmentObject = fields.get(index);
  return (
    <div key={index} className="mk-grouped-input">
      {adjustmentObject.item_variant_name && (
        <div className="form-group col-sm-4">
          <Field component={nameField} name={`${member}.item_variant_name`} />
        </div>
      )}
      {!adjustmentObject.item_variant_name && (
        <div className="form-group col-sm-4">
          <Field component={nameField} name={`${member}.item_name`} />
        </div>
      )}
      <div className="form-group col-sm-4">
        <Field component={stockField} name={`${member}.beginning_stock`} />
      </div>
      <div className="form-group col-sm-4" style={{ paddingRight: 0 }}>
        <Field
          component={SettingField}
          name={`${member}.quantity`}
          className="form-control"
          positiveNumberOnly
          maxFractionDigits={0}
          normalize={toNonNegative}
        />
      </div>
    </div>
  );
};

const renderFieldArrayItems = ({ fields }) => {
  return (
    <div className="row mk-grouped-list-input">
      <div className="col-xs-12">{fields.map(renderField)}</div>
    </div>
  );
};

class AddItemsModal extends React.Component {
  render() {
    const { showAddItemsModal, addItems, namespace, addItemsForm } = this.props;
    const { temporaryItem } = addItems;
    const disableBtn =
      !addItemsForm.items ||
      !addItemsForm.items.length ||
      addItems.itemHasRecipe;
    let options;
    if (namespace === 'items') {
      options = addItems.items.map(item => {
        return { value: item.id, label: item.name, image: item.image.url };
      });
    } else if (namespace === 'ingredients') {
      options = addItems.ingredients.map(ing => {
        return { value: ing.id, label: ing.name, image: ing.image.url };
      });
    }

    return (
      <Modal
        show={showAddItemsModal}
        backdrop="static"
        dialogClassName={styles.dialog}
      >
        <ModalHeader title={this._title()} />
        <form onSubmit={this.props.handleSubmit}>
          <Modal.Body className={styles.modalBody}>
            <Field
              component={SearchModal}
              type="text"
              name="search-item"
              placeholder={this._selectPlaceholder()}
              options={options}
              isHiddenSuggestion
              hasImproveModal
              onClickItem={this._onChangeSelect}
              onInputChange={this._onChangeKeyword}
              inputValue={addItems.selectedId}
              onMenuScrollToBottom={this._onSearchReachBottom}
              isHasMore={this._hasMore()}
              isLoading={addItems.isLoading}
            />
            <ItemHasRecipe
              hasRecipe={addItems.itemHasRecipe}
              onClickIngredient={this._clickIngredient}
            />
            {!temporaryItem && (
              <ListItemModal
                items={options}
                onSelectItem={this._onChangeSelect}
                onMenuScrollToBottom={this._onSearchReachBottom}
                isHasMore={this._hasMore()}
              />
            )}
            {!addItems.itemHasRecipe && (
              <div
                className={`${temporaryItem ? styles['selected-table'] : ''}`}
              >
                {addItems.alreadyAddedAlert && (
                  <div className={styles['warning-message']}>
                    <WarningMessage>
                      This {namespace} already added, go to{' '}
                      <a onClick={this._onHide}>
                        <i>Adjustment stock table</i>
                      </a>{' '}
                      to edit
                    </WarningMessage>
                  </div>
                )}
                {this._shouldRenderForm() && temporaryItem && (
                  <div className={styles['item-name']}>
                    <span> {temporaryItem.name} </span>
                  </div>
                )}
                {this._shouldRenderForm() && (
                  <table
                    className={`${styles['table-header']} table table-truncate`}
                  >
                    <thead>
                      <tr>
                        <th className="text-center" width="30%">
                          {addItemsForm.items &&
                            addItemsForm.items.length > 1 &&
                            namespace === 'items' &&
                            'Variant'}
                          {addItemsForm.items &&
                            addItemsForm.items.length === 1 &&
                            namespace === 'items' &&
                            'Item'}
                          {namespace === 'ingredients' && 'UNIT'}
                        </th>
                        <th className="text-center" width="30%">
                          In Stock
                        </th>
                        <th className="text-center" width="30%">
                          Actual Stock
                        </th>
                      </tr>
                    </thead>
                  </table>
                )}
                {namespace === 'items' && this._shouldRenderForm() && (
                  <FieldArray name="items" component={renderFieldArrayItems} />
                )}
                {namespace === 'ingredients' &&
                  this._shouldRenderForm() &&
                  this._renderIngredientFields()}
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <span className="pull-left">
              <button
                className="btn btn-default"
                type="button"
                onClick={this._onHide}
              >
                Cancel
              </button>
            </span>
            <span className="pull-right">
              {namespace === 'items' && (
                <button
                  className={
                    disableBtn
                      ? `btn ${styles.disableBtnAddItem}`
                      : 'btn btn-primary'
                  }
                  disabled={disableBtn}
                  onClick={this.props.handleSubmit(this._onSubmit)}
                >
                  Add
                </button>
              )}
              {namespace === 'ingredients' && (
                <button
                  className={
                    !addItemsForm.ingredient_id
                      ? `btn ${styles.disableBtnAddItem}`
                      : 'btn btn-primary'
                  }
                  disabled={!addItemsForm.ingredient_id}
                  onClick={this.props.handleSubmit(this._onSubmit)}
                >
                  Add
                </button>
              )}
            </span>
          </Modal.Footer>
        </form>
      </Modal>
    );
  }

  _onSearchReachBottom = () => {
    const {
      namespace,
      dispatch,
      addItems: { currentPage, totalPage, items, ingredients, keyword },
      adjustmentForm,
    } = this.props;
    if (currentPage < totalPage) {
      if (namespace === 'items') {
        dispatch(
          addItemsGetItemsRequest(
            {
              outlet_id: adjustmentForm.outlet_id,
              page: currentPage + 1,
              per_page: 100,
              no_categories: true,
              tracked: true,
              keyword,
            },
            items
          )
        );
      } else {
        dispatch(
          addItemsGetIngredientsRequest(
            {
              outlet_id: adjustmentForm.outlet_id,
              page: currentPage + 1,
              per_page: 100,
              no_categories: true,
              keyword,
            },
            ingredients
          )
        );
      }
    }
  };

  _onSubmit = values => {
    const {
      addItems: { selectedId },
    } = this.props;
    // kalo gak ada item yang diselect, don't do anything
    if (selectedId) {
      return this.props.onSubmit(values);
    }
  };

  _onOpen = () => {
    this.props.dispatch(addItemsHideAlreadyAddedAlert());
    this.props.dispatch(initialize('addItems', {}));
  };

  _onChangeSelect = dropdownVal => {
    const {
      addItems: { items, ingredients },
      dispatch,
      namespace,
      adjustmentForm,
    } = this.props;
    let selected = null;
    if (namespace === 'items') {
      items.forEach((i, index) => {
        if (dropdownVal.value === i.id) {
          selected = items[index];
        }
      });
    } else {
      ingredients.forEach((i, index) => {
        if (dropdownVal.value === i.id) {
          selected = ingredients[index];
        }
      });
    }

    if (selected) {
      dispatch(addItemsOnChangeSelect(selected, namespace, adjustmentForm));
    }
  };

  _onChangeKeyword = value => {
    const { dispatch, adjustmentForm, namespace } = this.props;
    dispatch(addItemsOnSearch(value, adjustmentForm.outlet_id, namespace));
  };

  _onHide = event => {
    event.preventDefault();
    event.stopPropagation();
    const { dispatch } = this.props;
    dispatch(cancelAddItems());
  };

  _title = () => {
    const { namespace } = this.props;
    if (namespace === 'items') {
      return 'Add Items';
    }
    return 'Add Ingredients';
  };

  _selectPlaceholder = () => {
    const { namespace } = this.props;
    if (namespace === 'items') {
      return 'Search items';
    }
    return 'Search ingredients';
  };

  _shouldRenderForm = () => {
    const {
      namespace,
      addItems: { selectedId },
      addItemsForm,
    } = this.props;
    if (namespace === 'items') {
      return (
        !!selectedId && addItemsForm.items && addItemsForm.items.length > 0
      );
    }
    return !!selectedId && addItemsForm.ingredient_id;
  };

  _renderIngredientFields = () => {
    return (
      <div className="mk-grouped-list-input">
        <div className="mk-grouped-input">
          <div className="form-group col-sm-4">
            <Field name="unit_name" component={nameField} />
          </div>
          <div className="form-group col-sm-4">
            <Field name="beginning_stock" component={stockField} />
          </div>
          <div className="form-group col-sm-4">
            <Field
              name="quantity"
              component={SettingField}
              positiveNumberOnly
              maxFractionDigits={2}
              normalize={toNonNegative}
            />
          </div>
        </div>
      </div>
    );
  };

  _clickIngredient = () => {
    const {
      dispatch,
      search: {
        date: { startDate, endDate },
      },
      keyword,
    } = this.props;
    const params = {
      page: 1,
      start: startDate.format('D/M/Y'),
      end: endDate.format('D/M/Y'),
      keyword,
    };
    dispatch(askConfirmAction(onChangeNamespace('ingredients', params)));
  };

  _hasMore = () => {
    const {
      addItems: { currentPage, totalPage },
    } = this.props;
    return currentPage < totalPage;
  };
}

const selector = formValueSelector('addItems');

function mapStateToProps(state) {
  const { showAddItemsModal, addItems, outlets } = state.inventory.adjustment;
  return {
    showAddItemsModal,
    addItems,
    outlets,
    adjustmentForm: getFormValues('adjustment')(state),
    search: getFormValues('search')(state),
    addItemsForm: {
      items: selector(state, 'items'),
      ingredient_id: selector(state, 'ingredient_id'),
    },
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

const mapForm = {
  form: 'addItems',
  validate,
  touchOnBlur: true,
  touchOnChange: true,
  touchOnValidate: false,
};

const connected = reduxForm(mapForm)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(AddItemsModal)
);

export default connected;
